/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SubscriberPaymentStepErrorSummary {
  error?: string;
  paymentRoundId?: number;
  step?: SubscriberPaymentStepErrorSummary.StepEnum;
  total?: number;
}
export namespace SubscriberPaymentStepErrorSummary {
  export type StepEnum =
    | 'VALIDATION'
    | 'PAYMENT'
    | 'ACTIVATION'
    | 'SUBSCRIBER_EDITION'
    | 'FINISHED';
  export const StepEnum = {
    VALIDATION: 'VALIDATION' as StepEnum,
    PAYMENT: 'PAYMENT' as StepEnum,
    ACTIVATION: 'ACTIVATION' as StepEnum,
    SUBSCRIBEREDITION: 'SUBSCRIBER_EDITION' as StepEnum,
    FINISHED: 'FINISHED' as StepEnum
  };
}
